var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "first-time-modal" },
    [
      _c("modal-header", {
        attrs: {
          "logo-img-src": require("@/assets/image/homebase/aone_logo.svg"),
          "on-modal-close": _vm.close
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-center pt-3 pb-5" }, [
        _c("div", { staticClass: "modal-body text-center" }, [
          _c(
            "div",
            {
              staticClass: "modal-description pb-4",
              on: { click: _vm.handleContentClick }
            },
            [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    this.removeInheritedStyles(this.campaignData.Copy)
                  )
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "max-width": "640px" } }, [
            _c("div", [
              this.campaignData.VideoURL
                ? _c("div", [
                    _c(
                      "video",
                      {
                        attrs: {
                          controls: "",
                          poster: this.campaignData.GIFURL.Url
                        }
                      },
                      [
                        _c("source", {
                          attrs: {
                            src: this.campaignData.VideoURL.Url,
                            type: "video/mp4"
                          }
                        })
                      ]
                    )
                  ])
                : _c("div", [
                    _c("img", {
                      staticClass: "campaign-gif",
                      attrs: { src: this.campaignData.GIFURL.Url, alt: "GIF" }
                    })
                  ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("modal-footer", {
        staticClass: "text-center",
        attrs: { buttonConfigs: [_vm.buttonConfig] }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3056682", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3056682","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/modals/OneMobileModal.vue
// module id = null
// module chunks = 